module.exports = __webpack_public_path__ + "static/media/13.7e7db340.jpg";